import PropTypes from 'prop-types';
import React from 'react';

import i18n from '../../i18n';

import Conversation from '../../models/Conversation';
import Exchange from '../../models/Exchange';
import User from '../../models/User';

import DepositRow from './DepositRow';
import GuestpointsRow from './GuestpointsRow';
import InsuranceRow from './InsuranceRow';
import SubscriptionRow from './SubscriptionRow';
import AssistanceRow from './AssistanceRow';
import PromoGPInfoLabel from './PromoGPInfoLabel';
import { Icon } from '@homeexchange/design';

export default class ExchangeResume extends React.Component {
    static propTypes = {
        currency: PropTypes.string.isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        exchange: PropTypes.instanceOf(Exchange).isRequired
    };

    constructor(props) {
        super(props);
        this.homeRef = React.createRef();
    }

    componentDidMount() {
        this.loadImage();
    }

    componentDidUpdate() {
        this.loadImage();
    }

    loadImage() {
        $(this.homeRef.current)
            .find('.home-picture-content')
            .each((index, element) => {
                // remove "lazyloading" class (loader) on picture loaded
                if (element.getAttribute('data-picture')) {
                    const img = new Image();
                    img.onload = function () {
                        element.style.backgroundImage = `url(${this.src})`;
                        $(element).closest('.lazyloading').removeClass('lazyloading');
                    };
                    img.onerror = function () {
                        $(element).addClass('no-picture');
                        $(element).closest('.lazyloading').removeClass('lazyloading');
                    };
                    img.src = element.getAttribute('data-picture');
                } else {
                    $(element).addClass('no-picture');
                    $(element).closest('.lazyloading').removeClass('lazyloading');
                }
            });
    }

    isUserGuest() {
        return this.props.exchange.get('guest').id == this.props.user.id;
    }

    renderProducts() {
        const productsRows = [];
        productsRows.push(
            <>
                <GuestpointsRow
                    key="guestpoints"
                    conversation={this.props.conversation}
                    exchange={this.props.exchange}
                    user={this.props.user}
                />
                {this.props.conversation.get('promo_gp') && (
                    <PromoGPInfoLabel amount={this.props.conversation.get('promo_gp')} />
                )}
            </>
        );

        if (!this.props.exchange.usesPackSystem()) {
            productsRows.push(
                <DepositRow
                    key="deposit"
                    currency={this.props.currency}
                    exchange={this.props.exchange}
                    user={this.props.user}
                />
            );
            // Old insurance system
            productsRows.push(
                <InsuranceRow
                    key="insurance"
                    currency={this.props.currency}
                    exchange={this.props.exchange}
                    user={this.props.user}
                />
            );
            productsRows.push(
                <AssistanceRow
                    key="assistance"
                    currency={this.props.currency}
                    exchange={this.props.exchange}
                    user={this.props.user}
                />
            );
        } else {
            productsRows.push(
                <SubscriptionRow
                    key="subscription"
                    currency={this.props.currency}
                    exchange={this.props.exchange}
                    isGuest={this.isUserGuest()}
                    isSubscriber={this.props.user.isSubscriber()}
                    user={this.props.user}
                />
            );
        }
        return productsRows;
    }

    render() {
        const { exchange } = this.props;

        const home = exchange.get('home');
        const startOn = exchange.get('start_on');
        const endOn = exchange.get('end_on');

        return (
            <div className="exchange-resume scrollable">
                <article className="home" data-home={home.id} ref={this.homeRef}>
                    <a
                        className="home-picture lazyloading"
                        href={i18n.t('home:home.view.url', { id: home.id })}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="home-picture-content" data-picture={home.picture(400, 225, false)} />
                    </a>
                    <a
                        className="header"
                        href={i18n.t('home:home.view.url', { id: home.id })}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <span className="title">{home.title()}</span>
                        <div>
                            <Icon name="Moon" />
                            <span>
                                {i18n.t('common:duration.night', {
                                    count: exchange.getNightNb()
                                })}
                            </span>
                        </div>
                        <span className="location">{home.location()}</span>
                    </a>
                </article>

                <div className="form-group-inline">
                    <div className="form-group editable-field guest_nb">
                        <label>{i18n.t('common:guests')}</label>
                        <span className="value">{exchange.get('guest_nb')}</span>
                    </div>
                    <div className="form-group editable-field start_on">
                        <label>{i18n.t('exchange:start_on')}</label>
                        <span
                            className="value"
                            dangerouslySetInnerHTML={{
                                __html: [
                                    moment(startOn).format('DD'),
                                    moment(startOn).format('MMM'),
                                    moment(startOn).format('YY')
                                ]
                                    .map((part) => `<span>${part}</span>`)
                                    .join(' ')
                            }}
                        />
                    </div>
                    <div className="form-group editable-field end_on">
                        <label>{i18n.t('exchange:end_on')}</label>
                        <span
                            className="value"
                            dangerouslySetInnerHTML={{
                                __html: [
                                    moment(endOn).format('DD'),
                                    moment(endOn).format('MMM'),
                                    moment(endOn).format('YY')
                                ]
                                    .map((part) => `<span>${part}</span>`)
                                    .join(' ')
                            }}
                        />
                    </div>
                </div>

                <div className="form-group exchange-type">
                    <div className="modify-exchange">
                        <label>{i18n.t('exchange:exchange.type')}</label>
                        <div className="no-cursor" onClick={this.toggleEditableExchangeType}>
                            <span>
                                {i18n.t(`exchange:${this.props.conversation.getExchangeTypeShort()}`)}
                            </span>
                        </div>
                    </div>
                </div>

                {this.renderProducts()}
            </div>
        );
    }
}
